<template>
  <div class="video-watch">
    <iframe
      class="video-watch__iframe"
      :src="video.player"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
import { asyncModal } from "@/components/ui/modal/";

const VideoWatch = {
  name: "VideoWatch",
  props: {
    video: {
      type: Object,
      required: true
    }
  }
};

export default VideoWatch;

export function openModal(video) {
  return asyncModal({
    name: "video-modal",
    component: VideoWatch,
    titled: false,
    props: {
      video
    }
  });
}
</script>

<style lang="scss">
.modal.video-modal {
  width: auto;
  .modal-card {
    max-width: 100%;
    padding: 0px;
    background: none;
  }
  .modal__close {
    top: -35px;
    right: 0;
  }
}

.video-watch {
  position: relative;
  width: 1280px;
  padding-bottom: 56.25%;
  max-width: 90vw;
  &__iframe {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
